import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { ReactComponent as IconFacebook } from "../../../../icons/facebook.svg";
import { ReactComponent as IconFriendsSharing } from "../../../../icons/friends_sharing.svg";
import { ReactComponent as IconGoogleMonochrome } from "../../../../icons/google-monochrome.svg";
import { ReactComponent as IconImage } from "../../../../icons/image.svg";
import { ReactComponent as IconImages } from "../../../../icons/images.svg";
import { ReactComponent as IconInstagram } from "../../../../icons/instagram.svg";
import { ReactComponent as IconLayout } from "../../../../icons/layout.svg";
import { ReactComponent as IconOptions } from "../../../../icons/options.svg";
import { ReactComponent as IconRotation } from "../../../../icons/rotate-cw.svg";
import { ReactComponent as IconSmartphone } from "../../../../icons/smartphone.svg";
import { ReactComponent as IconType } from "../../../../icons/type.svg";
import Button from "../../../atoms/Button";
import "./style.scss";

interface Props {
  disabled?: boolean;
  label: string;
  onClick: () => void;
  opened: boolean;
  type:
    | "layout"
    | "options"
    | "photos"
    | "rotation"
    | "type"
    | "facebook"
    | "friends_sharing"
    | "google_photos"
    | "instagram"
    | "mobile_upload"
    | "unsplash"
    | "upload";
}
const PanelMenuItem: FunctionComponent<Props> = ({
  disabled = false,
  label,
  onClick,
  opened,
  type,
}) => {
  let Icon;
  switch (type) {
    case "layout":
      Icon = IconLayout;
      break;
    case "options":
      Icon = IconOptions;
      break;
    case "photos":
      Icon = IconImage;
      break;
    case "rotation":
      Icon = IconRotation;
      break;
    case "type":
      Icon = IconType;
      break;
    case "friends_sharing":
      Icon = IconFriendsSharing;
      break;
    case "facebook":
      Icon = IconFacebook;
      break;
    case "google_photos":
      Icon = IconGoogleMonochrome;
      break;
    case "instagram":
      Icon = IconInstagram;
      break;
    case "mobile_upload":
      Icon = IconSmartphone;
      break;
    case "unsplash":
      Icon = IconImage;
      break;
    case "upload":
      Icon = IconImages;
      break;
    default: {
      const exhaustiveCheck: never = type;
      throw new Error(`Unsupported panelMenu type ${exhaustiveCheck as string}`);
    }
  }

  return (
    <div
      className={classNames("PanelMenuItem", {
        "PanelMenuItem--disabled": disabled,
        "PanelMenuItem--opened": opened,
      })}
    >
      <Button
        disabled={disabled}
        size="big-round"
        type={opened ? "primary-lightest" : "neutral-inverted"}
        onClick={onClick}
      >
        <Icon />
      </Button>
      <span className="PanelMenuItem-label">{label}</span>
    </div>
  );
};

export default PanelMenuItem;
